/**
 * Cart Progress Bar — assets/cart-progress-bar.js
 * ─────────────────────────────────────────────────
 * Compatível com: Dawn, Refresh, e temas Shopify nativos.
 *
 * Integração com temas Dawn/Refresh:
 * - Escuta o evento nativo 'cart:refresh' e 'cart-update'
 * - Conecta com o custom element <cart-drawer> via evento
 * - MutationObserver como fallback para side carts injetados
 *
 * Ícones: image_picker do schema OU SVG inline de caminhão como fallback.
 * Goals: máximo 3, reward tipo "envio grátis".
 * Thresholds: lidos do data-goals (JSON do metafield, em centavos).
 */

(function () {
  'use strict';

  // ─── SVG de fallback (caminhão) — usado quando não há ícone no schema ───
  const TRUCK_SVG = `<svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 122.88 61.14" aria-hidden="true" style="width:20px;height:20px;fill:#000;"><style>.cpb-truck{fill-rule:evenodd;clip-rule:evenodd;}</style><path class="cpb-truck" d="M105.01,40.54c-5.7,0-10.3,4.63-10.3,10.3c0,5.7,4.63,10.3,10.3,10.3c5.7,0,10.3-4.63,10.3-10.3C115.31,45.14,110.68,40.54,105.01,40.54L105.01,40.54zM61.86,41.46c-5.2,0-9.38,4.22-9.38,9.38c0,5.2,4.22,9.38,9.38,9.38c5.2,0,9.38-4.22,9.38-9.38C71.24,45.64,67.02,41.46,61.86,41.46L61.86,41.46zM61.86,47.23c-1.99,0-3.61,1.62-3.61,3.61s1.62,3.61,3.61,3.61c1.99,0,3.61-1.62,3.61-3.61S63.85,47.23,61.86,47.23L61.86,47.23zM24.11,41.46c-5.2,0-9.38,4.22-9.38,9.38c0,5.2,4.22,9.38,9.38,9.38c5.2,0,9.38-4.22,9.38-9.38C33.5,45.64,29.28,41.46,24.11,41.46L24.11,41.46zM24.11,47.23c-1.99,0-3.61,1.62-3.61,3.61s1.62,3.61,3.61,3.61c1.99,0,3.61-1.62,3.61-3.61S26.11,47.23,24.11,47.23L24.11,47.23zM47.37,53.53H38.1v-3.01h9.27V53.53L47.37,53.53zM10.46,53.53H5.63c-1.55,0-2.95-0.66-3.96-1.71c-1.01-1.05-1.65-2.5-1.65-4.02V8.06c0-2.44-0.36-4.44,1.62-6.42C2.66,0.63,4.05,0,5.6,0h73.32c1.55,0,2.95,0.63,3.96,1.65c1.01,1.01,1.65,2.41,1.65,3.96l0,7.26l10.27,0.07l3.62,0.02l0,0c0.73,0.79,1.4,1.6,2.01,2.42c2.71,3.64,4.23,7.94,4.52,12.11l16.38,6.27l1.55,16.51h-5.01c-2.31-18.03-25.03-15.84-25.73,0l-7.61,0v1.74c0,0.86-0.67,1.52-1.52,1.52l-6.69,0v-3.04h5.16V5.61c0-0.7-0.28-1.33-0.76-1.81c-0.48-0.48-1.11-0.76-1.81-0.76H5.6c-0.7,0-1.33,0.29-1.81,0.76C2.76,4.77,3.07,6.43,3.07,7.7v40.1c0,0.73,0.32,1.43,0.79,1.93c0.48,0.48,1.08,0.79,1.77,0.79h4.82V53.53L10.46,53.53zM94.46,17.89l-5.83-0.09v9.69h11.02C99.12,23.98,97.49,20.9,94.46,17.89L94.46,17.89zM105.01,46.88c-2.19,0-3.96,1.77-3.96,3.96c0,2.19,1.77,3.96,3.96,3.96c2.19,0,3.96-1.77,3.96-3.96C108.97,48.65,107.2,46.88,105.01,46.88L105.01,46.88z"/></svg>`;

  const SELECTOR = '[data-cart-progress-bar]';

  // ─── Formata valor em centavos usando o money_format do Shopify ───────────
  function formatMoney(cents, moneyFormat) {
    const units   = (cents / 100).toFixed(2);
    const noDecim = String(Math.floor(cents / 100));
    const comma   = (cents / 100).toFixed(2).replace('.', ',');
    const noDecimComma = noDecim;

    return moneyFormat
      .replace('{{amount}}',                              units)
      .replace('{{amount_no_decimals}}',                  noDecim)
      .replace('{{amount_with_comma_separator}}',         comma)
      .replace('{{amount_no_decimals_with_comma_separator}}', noDecimComma);
  }

  // ─── Renderiza markers e labels estáticos (só uma vez por instância) ──────
  function renderStructure(goals, iconMap, markersEl, labelsEl) {
    markersEl.innerHTML = '';
    labelsEl.innerHTML  = '';

    const maxGoal = goals[goals.length - 1].threshold;

    goals.forEach((goal, i) => {
      const pct = (goal.threshold / maxGoal) * 100;

      /* Marker */
      const marker = document.createElement('div');
      marker.className = 'cpb-marker';
      marker.style.left = pct + '%';
      marker.dataset.goalIndex = i;

      if (iconMap[i]) {
        const img = document.createElement('img');
        img.src    = iconMap[i];
        img.alt    = '';                // decorativo — label está abaixo
        img.width  = 16;
        img.height = 16;
        img.loading = 'lazy';
        marker.appendChild(img);
      } else {
        // Fallback: ícone de caminhão SVG
        const wrap = document.createElement('span');
        wrap.className = 'cpb-marker-icon';
        wrap.innerHTML = TRUCK_SVG;
        marker.appendChild(wrap);
      }

      markersEl.appendChild(marker);

      /* Label */
      const label = document.createElement('span');
      label.className = 'cpb-label';
      const totalGoals = goals.length;
      const isLast  = i === totalGoals - 1;
      const isFirst = i === 0;
      label.style.left = (isLast ? 96 : pct) + '%';
      if (totalGoals === 1) {
        // Único goal: centra sempre
        label.style.transform = 'translateX(-50%)';
      } else if (isLast) {
        // Último de vários: ancora à direita do marker
        label.style.transform = 'translateX(-100%)';
      } else if (isFirst) {
        // Primeiro de vários: ancora à esquerda
        label.style.transform = 'translateX(0%)';
      } else {
        // Intermédios: centra
        label.style.transform = 'translateX(-50%)';
      }
      label.textContent = goal.label;
      labelsEl.appendChild(label);
    });
  }

  // Usa o subtotal apresentado no carrinho, já com cupões e descontos aplicados.
  function getDisplayedCartSubtotal() {
    const totals = Array.from(document.querySelectorAll('[data-cart-total]'));
    const visible = totals.filter(el => el.getClientRects().length > 0);
    const candidates = visible.concat(totals.filter(el => el.getClientRects().length === 0));

    for (const el of candidates) {
      const raw = (el.textContent || '').replace(/\s/g, '').replace(/[^0-9,.-]/g, '');
      if (!raw) continue;

      const decimalAt = Math.max(raw.lastIndexOf(','), raw.lastIndexOf('.'));
      const normalized = decimalAt >= 0
        ? raw.slice(0, decimalAt).replace(/[.,]/g, '') + '.' + raw.slice(decimalAt + 1).replace(/[.,]/g, '')
        : raw;
      const amount = Number(normalized);
      if (Number.isFinite(amount)) return Math.round(amount * 100);
    }

    return null;
  }

  function updateBarWithSubtotal(wrapper, fallbackTotal) {
    const apply = () => updateBar(wrapper, getDisplayedCartSubtotal() ?? fallbackTotal);
    apply();
    [100, 350, 800].forEach(delay => setTimeout(apply, delay));
  }

  // ─── Atualiza estado visual da barra ─────────────────────────────────────
  function updateBar(wrapper, cartTotal) {
    const goals       = wrapper._cpbGoals;
    const moneyFormat = wrapper._cpbMoneyFormat;
    const textRem     = wrapper._cpbTextRemaining;
    const textAll     = wrapper._cpbTextAllUnlocked;

    const fillEl    = wrapper.querySelector('.cpb-fill');
    const messageEl = wrapper.querySelector('.cpb-message');
    const markerEls = wrapper.querySelectorAll('.cpb-marker');
    const labelEls  = wrapper.querySelectorAll('.cpb-label');

    if (!fillEl || !goals.length) return;

    const maxGoal = goals[goals.length - 1].threshold;
    const pct     = Math.min((cartTotal / maxGoal) * 100, 100);

    // Barra
    fillEl.style.width = pct + '%';
    fillEl.setAttribute('aria-valuenow', Math.round(pct));

    // Goals atingidos
    let lastReached = -1;
    goals.forEach((g, i) => {
      if (cartTotal >= g.threshold) lastReached = i;
    });

    const nextIndex = lastReached + 1;
    const nextGoal  = goals[nextIndex];
    const prevReached = wrapper._cpbLastReached ?? -1;

    // Markers
    markerEls.forEach((el, i) => {
      const wasActive = el.classList.contains('cpb-marker--active');

      el.classList.toggle('cpb-marker--active',   i <= lastReached);
      el.classList.toggle('cpb-marker--next',      i === nextIndex);
      el.classList.toggle('cpb-marker--inactive',  i > nextIndex);

      // Animação de celebração ao atingir novo goal
      if (i <= lastReached && !wasActive) {
        el.classList.add('cpb-marker--celebrate');
        el.addEventListener('animationend', () => {
          el.classList.remove('cpb-marker--celebrate');
        }, { once: true });
      }
    });

    // Labels
    labelEls.forEach((el, i) => {
      el.classList.toggle('cpb-label--active', i <= lastReached);
    });

    // Mensagem
    messageEl.classList.toggle('cpb-message--congrats', !nextGoal);

    if (nextGoal) {
      const remaining = nextGoal.threshold - cartTotal;
      const formatted = formatMoney(remaining, moneyFormat);
      messageEl.innerHTML = textRem
        .replace('{amount}', `<strong>${formatted}</strong>`)
        .replace('{label}',  nextGoal.label);
    } else {
      messageEl.textContent = textAll;
    }

    wrapper._cpbLastReached = lastReached;
  }

  // ─── Fetch /cart.js e atualiza ────────────────────────────────────────────
  function fetchCart(wrapper) {
    fetch('/cart.js', { cache: 'no-store' })
      .then(r => r.json())
      .then(cart => {
        wrapper.removeAttribute('data-loading');
        updateBarWithSubtotal(wrapper, cart.total_price);
      })
      .catch(err => {
        wrapper.removeAttribute('data-loading');
        console.warn('[CartProgressBar] Erro ao fetch /cart.js', err);
      });
  }

  // ─── Inicializa uma instância ─────────────────────────────────────────────
  function initBar(wrapper) {
    if (wrapper._cpbReady) return;
    wrapper._cpbReady = true;

    // Parse goals — data-goals é um array direto: [{threshold, label}, ...]
    let goals;
    try {
      const parsed = JSON.parse(wrapper.dataset.goals || '[]');
      goals = (Array.isArray(parsed) ? parsed : (parsed.goals || [])).slice(0, 3);
    } catch (e) {
      console.warn('[CartProgressBar] JSON invalido em data-goals', e);
      return;
    }

    if (!goals.length) return;

    wrapper._cpbGoals          = goals;
    wrapper._cpbMoneyFormat    = wrapper.dataset.moneyFormat || '{{amount}} €';
    wrapper._cpbTextRemaining  = wrapper.dataset.textRemaining  || 'Faltam {amount} para {label}';
    wrapper._cpbTextAllUnlocked= wrapper.dataset.textAllUnlocked || '🎉 Tens envio grátis!';
    wrapper._cpbLastReached    = -1;

    // Recolhe ícones do schema
    const iconMap = {};
    wrapper.querySelectorAll('.cpb-icons-data [data-goal-index]').forEach(el => {
      const idx = parseInt(el.dataset.goalIndex, 10);
      const url = el.dataset.iconUrl;
      if (url) iconMap[idx] = url;
    });

    // Renderiza estrutura estática
    renderStructure(
      goals,
      iconMap,
      wrapper.querySelector('.cpb-markers'),
      wrapper.querySelector('.cpb-labels')
    );

    // Fetch inicial
    wrapper.setAttribute('data-loading', '');
    fetchCart(wrapper);

    // Expõe métodos no elemento para integração manual
    wrapper.cpbRefresh = () => fetchCart(wrapper);
    wrapper.cpbUpdate  = (cents) => updateBarWithSubtotal(wrapper, cents);
  }

  // ─── Inicializa todas as instâncias no DOM ────────────────────────────────
  function initAll() {
    document.querySelectorAll(SELECTOR).forEach(initBar);
  }

  // ─── Eventos do carrinho ─────────────────────────────────────────────────
  const CART_EVENTS = [
    'cart:refresh', 'cart:update', 'cart:updated', 'cart-update',
    'cart:change', 'shopify:cart:update',
  ];

  function onCartChange() {
    document.querySelectorAll(SELECTOR).forEach(el => {
      if (el.cpbRefresh) el.cpbRefresh();
    });
  }

  CART_EVENTS.forEach(ev => document.addEventListener(ev, onCartChange));

  // ─── Intercepta fetch e XMLHttpRequest ────────────────────────────────────
  // Apanha qualquer pedido ao carrinho independentemente do tema.
  // Funciona com Dawn, Refresh, e temas custom que usam fetch() ou XHR.

  // Interceta fetch()
  const _originalFetch = window.fetch;
  window.fetch = function (...args) {
    const url = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url) || '';
    const isCartRequest = /\/cart\/(add|change|update|clear)/.test(url);
    return _originalFetch.apply(this, args).then(response => {
      if (isCartRequest && response.ok) {
        // Clona a resposta para não consumir o body original
        response.clone().json().then(data => {
          // Shopify devolve total_price diretamente em /cart/change e /cart/update
          if (typeof data.total_price !== 'undefined') {
            document.querySelectorAll(SELECTOR).forEach(el => {
              if (el.cpbUpdate) el.cpbUpdate(data.total_price);
            });
          } else {
            onCartChange();
          }
        }).catch(() => onCartChange());
      }
      return response;
    });
  };

  // Intercepta XMLHttpRequest (fallback para temas mais antigos)
  const _XHROpen  = XMLHttpRequest.prototype.open;
  const _XHRSend  = XMLHttpRequest.prototype.send;

  XMLHttpRequest.prototype.open = function (method, url, ...rest) {
    this._cpbUrl = url;
    return _XHROpen.call(this, method, url, ...rest);
  };

  XMLHttpRequest.prototype.send = function (...args) {
    if (this._cpbUrl && /\/cart\/(add|change|update|clear)/.test(this._cpbUrl)) {
      this.addEventListener('load', function () {
        try {
          const data = JSON.parse(this.responseText);
          if (typeof data.total_price !== 'undefined') {
            document.querySelectorAll(SELECTOR).forEach(el => {
              if (el.cpbUpdate) el.cpbUpdate(data.total_price);
            });
          } else {
            onCartChange();
          }
        } catch (e) {
          onCartChange();
        }
      });
    }
    return _XHRSend.apply(this, args);
  };

  // ─── Integração específica com Dawn <cart-drawer> ─────────────────────────
  //
  // O Dawn usa fetch interceptado no custom element CartDrawer.
  // Sobrepõe o método onSuccess para disparar a atualização da barra.
  function patchDawnCartDrawer() {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer || drawer._cpbPatched) return;
    drawer._cpbPatched = true;

    const originalOnSuccess = drawer.onSuccess?.bind(drawer);
    if (originalOnSuccess) {
      drawer.onSuccess = function (...args) {
        const result = originalOnSuccess(...args);
        onCartChange();
        return result;
      };
    }

    // Escuta também o evento nativo que o cart-drawer despacha
    drawer.addEventListener('cart-drawer:open', onCartChange);
  }

  // ─── Integração com Refresh <cart-notification> ───────────────────────────
  function patchRefreshCartNotification() {
    const notif = document.querySelector('cart-notification');
    if (!notif || notif._cpbPatched) return;
    notif._cpbPatched = true;

    const orig = notif.renderContents?.bind(notif);
    if (orig) {
      notif.renderContents = function (...args) {
        const result = orig(...args);
        onCartChange();
        return result;
      };
    }
  }

  // ─── MutationObserver global — inicializa barra injectada no DOM ──────────
  // (ex: side cart que renderiza depois do DOMContentLoaded)
  const domObserver = new MutationObserver(mutations => {
    let needsInit = false;
    for (const m of mutations) {
      for (const node of m.addedNodes) {
        if (node.nodeType !== 1) continue;
        if (node.matches?.(SELECTOR) || node.querySelector?.(SELECTOR)) {
          needsInit = true;
          break;
        }
      }
      if (needsInit) break;
    }
    if (needsInit) initAll();
  });

  // ─── Bootstrap ────────────────────────────────────────────────────────────
  function boot() {
    initAll();
    patchDawnCartDrawer();
    patchRefreshCartNotification();
    domObserver.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // ─── API pública ──────────────────────────────────────────────────────────
  window.CartProgressBar = {
    /** Força novo fetch a /cart.js em todas as instâncias */
    refresh() { onCartChange(); },
    /** Atualiza com total conhecido (em centavos) */
    update(cents) {
      document.querySelectorAll(SELECTOR).forEach(el => {
        if (el.cpbUpdate) el.cpbUpdate(cents);
      });
    },
  };

})();
